import { render, staticRenderFns } from "./en-tete-bon-facture.html?vue&type=template&id=796cfa35&scoped=true&external"
import script from "./en-tete-bon-facture.js?vue&type=script&lang=js&external"
export * from "./en-tete-bon-facture.js?vue&type=script&lang=js&external"
import style0 from "./en-tete-bon-facture.scss?vue&type=style&index=0&id=796cfa35&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796cfa35",
  null
  
)

export default component.exports